export const getIFrameInstance = (): string => {
  if (typeof window !== 'undefined') {
    const url = window.location.search;
    // eslint-disable-next-line no-useless-escape
    const instanceRegexp = /.*instance=([\[\]a-zA-Z0-9\.\-_]*?)(&|$|#).*/g;
    const instance = instanceRegexp.exec(url);
    return instance && instance[1] ? instance[1] : '';
  }
  return '';
};
